// Marketing & analytics loader for Endasphere.
// IDs are read from build-time env vars (REACT_APP_*). Each pixel only
// initializes when a valid, non-placeholder ID is present.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const TIKTOK_PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;

const isValid = (v) => typeof v === "string" && v.trim() !== "" && !v.includes("YOUR_");

let initialized = false;

function injectScript(src, async = true) {
  const s = document.createElement("script");
  s.src = src;
  s.async = async;
  document.head.appendChild(s);
  return s;
}

function initGA() {
  if (!isValid(GA_ID)) return;
  injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
}

function initMetaPixel() {
  if (!isValid(META_PIXEL_ID)) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
}

function initTikTok() {
  if (!isValid(TIKTOK_PIXEL_ID)) return;
  /* eslint-disable */
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
    ttq.setAndDefer = function (t, e) {
      t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); };
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) {
      for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
      return e;
    };
    ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner;
      ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r;
      ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
      ttq._o = ttq._o || {}; ttq._o[e] = n || {};
      var s = d.createElement("script"); s.type = "text/javascript"; s.async = !0; s.src = r + "?sdkid=" + e + "&lib=" + t;
      var a = d.getElementsByTagName("script")[0]; a.parentNode.insertBefore(s, a);
    };
    ttq.load(TIKTOK_PIXEL_ID);
    ttq.page();
  })(window, document, "ttq");
  /* eslint-enable */
}

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;
  try { initGA(); } catch (e) {}
  try { initMetaPixel(); } catch (e) {}
  try { initTikTok(); } catch (e) {}
}

// Fire a conversion/custom event across all connected platforms.
export function trackEvent(name, params = {}) {
  try { if (window.gtag) window.gtag("event", name, params); } catch (e) {}
  try { if (window.fbq) window.fbq("trackCustom", name, params); } catch (e) {}
  try { if (window.ttq) window.ttq.track(name, params); } catch (e) {}
  try { if (window.posthog) window.posthog.capture(name, params); } catch (e) {}
}

// Standard "Lead" conversion used by ad platforms for campaign optimization.
export function trackLead(params = {}) {
  try { if (window.gtag) window.gtag("event", "generate_lead", params); } catch (e) {}
  try { if (window.fbq) window.fbq("track", "Lead", params); } catch (e) {}
  try { if (window.ttq) window.ttq.track("SubmitForm", params); } catch (e) {}
  try { if (window.posthog) window.posthog.capture("lead_submitted", params); } catch (e) {}
}
